import * as React from "react";
import {
  SpinButton,
  Switch,
  Label,
  makeStyles,
  tokens,
  Field,
} from "@fluentui/react-components";

export interface ThumbnailSettingsProps {
  thumbnailSize: number;
  fitToCell: boolean;
  onSizeChange: (size: number) => void;
  onFitToCellChange: (fit: boolean) => void;
  disabled?: boolean;
}

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    marginTop: "4px",
    marginBottom: "4px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
  },
  label: {
    fontWeight: tokens.fontWeightSemibold,
    marginBottom: "2px",
  },
});

const ThumbnailSettings: React.FC<ThumbnailSettingsProps> = ({
  thumbnailSize,
  fitToCell,
  onSizeChange,
  onFitToCellChange,
  disabled,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <div className={styles.form}>
        <Field label="Thumbnail height (px)">
          <SpinButton
            value={thumbnailSize}
            min={16}
            max={256}
            step={8}
            onChange={(_e, data) => {
              if (data.value !== undefined && data.value !== null) {
                onSizeChange(data.value);
              } else if (data.displayValue !== undefined) {
                const parsed = parseInt(data.displayValue, 10);
                if (!isNaN(parsed) && parsed >= 16 && parsed <= 256) onSizeChange(parsed);
              }
            }}
            disabled={disabled}
          />
        </Field>

        <Field label="Positioning">
          <Switch
            label="Fit to cell"
            checked={fitToCell}
            onChange={(_e, data) => onFitToCellChange(data.checked)}
            disabled={disabled}
          />
        </Field>
      </div>
    </div>
  );
};

export default ThumbnailSettings;
